const moment = require('moment')
require('moment/locale/pt-br')

import Vue from 'vue'
Vue.use(require('vue-moment'), {
    moment
})

export default moment